module.exports = __webpack_public_path__ + "img/background.c969b409.png";